import { getCustomFields, getLeadTypes } from './leadFields';

export function LeadCustomFieldInputs({ values, setValues, leadType, setLeadType, inputStyle }) {
  const fields = getCustomFields();
  const types = getLeadTypes();
  if (!fields.length && !types.length) return null;

  const set = (id, v) => setValues({ ...values, [id]: v });
  const lbl = { fontSize: 11, fontWeight: 700, color: '#555', display: 'block', marginBottom: 3 };

  return (
    <div style={{ borderTop: '1px dashed #e5e7eb', margin: '4px 0 10px', paddingTop: 10 }}>
      {types.length > 0 && (
        <>
          <label style={lbl}>Lead type</label>
          <select style={inputStyle} value={leadType} onChange={e => setLeadType(e.target.value)}>
            <option value="">Select lead type</option>
            {types.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </>
      )}
      {fields.map(f => {
        const v = values[f.id];
        const star = f.required ? <span style={{ color: '#f44336' }}> *</span> : null;
        if (f.type === 'checkbox') {
          return (
            <label key={f.id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#444', margin: '4px 0 12px', cursor: 'pointer' }}>
              <input type="checkbox" checked={!!v} onChange={e => set(f.id, e.target.checked)} />
              {f.label}{star}
            </label>
          );
        }
        return (
          <div key={f.id}>
            <label style={lbl}>{f.label}{star}</label>
            {f.type === 'dropdown' ? (
              <select style={inputStyle} value={v ?? ''} onChange={e => set(f.id, e.target.value)}>
                <option value="">Select {f.label}</option>
                {(f.options || []).map(o => <option key={o} value={o}>{o}</option>)}
              </select>
            ) : (
              <input style={inputStyle} type={f.type === 'number' ? 'number' : f.type === 'date' ? 'date' : 'text'}
                placeholder={f.label} value={v ?? ''} onChange={e => set(f.id, e.target.value)} />
            )}
          </div>
        );
      })}
    </div>
  );
}
